<template>
  <div :class="clientType == 'pc' ? 'pc-aliplayer' : 'aliplayer'">
    <div id="fixed-player"></div>
  </div>
</template>

<script>
import pcCommonMethods from "../views/pcviews/mixins/index.js";
import { mapState } from 'vuex'
export default {
  props: {
    source: {
      type: String,
      default: () => ('')
    },
    clientType: {
      type: String,
      default: 'mobile'
    }
  },
  mixins: [pcCommonMethods],
  computed: {
    ...mapState({
      videoHeadTime: state => state.videoHeadTime,
      cur_data: state => state.cur_data,
    })
  },
  watch: {
    source(newVal) {
      this.$nextTick(() => {
        this.player.seek(0)
        this.$store.commit('videoTime', 0)
        this.$store.commit('videoHeadTime', 0)
        this.player.loadByUrl(newVal, 0);
        this.player.play();
      });
    },
  },
  data() {
    return {
      player: null,
      path: this.$route.path,
      finished: 0
    }
  },
   
  mounted() {
    this.$nextTick(() => {
      this.initPlayer(this.source)
    })
  },
  activated() {
    this.$nextTick(() => {
      this.initPlayer(this.source)
    })
  },
  beforeDestroy() {
    if (this.player) {
      if(!this.finished) this.$store.commit('videoHeadTime', this.player.getCurrentTime())
      this.player.dispose()
    }
  },
  deactivated() {
    if (this.player) {
      if(!this.finished) this.$store.commit('videoHeadTime', this.player.getCurrentTime())
      this.player.dispose()
    }
  },
  methods: {
    initPlayer(source) {
      // debugger
      let player_obj = {
        id: "fixed-player",
        width: "100%",
        height: '100%',
        autoplay: true,
        // playsinline: true, //H5是否内置播放
        // useH5Prism: true, //强制H5播放器
        controlBarVisibility: "always", //控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
        language: "zh-cn",
        source: source,
        isLive: false,
        preload: true,
        "skinLayout": [
          {
            "name": "controlBar",
            "align": "blabs",
            "x": 0,
            "y": 0,
            "children": [
              {
                "name": "progress",
                "align": "blabs",
                "x": 0,
                "y": 44
              },
              {
                "name": "playButton",
                "align": "tl",
                "x": 15,
                "y": 12
              },
              {
                "name": "timeDisplay",
                "align": "tl",
                "x": 10,
                "y": 7
              },
              {
                "name": "fullScreenButton",
                "align": "tr",
                "x": 10,
                "y": 12
              },
            ]
          }
        ],
      };
      this.player = new Aliplayer(player_obj);
      this.player.on('ended', () => {
        this.finished = 1
        this.$emit('videoEnd')
      })

      this.player.on('ready', () => {
         if(this.videoHeadTime) {
          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            this.player.loadByUrl(this.source, this.videoHeadTime)
          } else {
            this.player.seek(this.videoHeadTime)
          }
          this.$nextTick(() => {
            this.$store.commit('videoHeadTime', 0)
          })
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.aliplayer {
  width: 100%;
  height: 4.2rem;
  &.for-pc {
    height: 470px;
  }
}
.pc-aliplayer {
  height: 99%;
}
</style>
